define('views/parts/form/sliderbar',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils',
    'sliderbar',
    // templates
    'text!templates/parts/form/sliderbar.html',

], function(
    // Libs
    _, Backbone, Mustache, U,
    Sliderbar,
    // templates
    TSliderbar
) {

    var VSliderbar = Backbone.View.extend({
        template: TSliderbar,
        className: function() {
            return this.options.className || 'slider';
        },
        events: {
            'change .sliderbar': 'onChange',
        },

        regions: {
            slider: ".sliderbar",
        },

        initialize: function(opt) {
            var options = this.options = _.extend({
                color: false,
                labels: ["Min", "Max"],
            }, opt);

            if (!options.min) options.min = 1;
            if (!options.max) options.max = 10;
            if (!options.step) options.step = 1;
            if (!options.value) options.value = 10;

            options.slider = _.extend({
                min: options.min,
                max: options.max,
                step: options.step,
                value: options.value,
                tooltip_position: 'top'
            }, options.slider);

            this.listenTo(this.model, "change:" + options.attribute, this.onModelChange);
        },

        render: function() {
            if (this.slider) {
                this.slider.destroy();
            }

            // Render Template HTML with Mustache
            var html = Mustache.render(this.template, Mustache.getContext(this.options));
            this.$el.empty().append(html);

            this.generateZones();

            this.slider = new Sliderbar(this.zone.$slider.get(0), this.options.slider);
            this.slider.setValue(this.getValue());

            // Add Color if option is passed by the parent view
            this.setLevelClass();

            return this;
        },

        getValue: function() {
            var limits = this.options.slider,
                value = this.model.get(this.options.attribute);
            if (limits.min <= value && value <= limits.max) return value;
            return limits.value;
        },

        setLevelClass: function(value) {
            if (this.options.color) {
                var level = this.getValue();
                if (this.options.slider.reversed) { level = 11 - this.getValue(); }
                this.$el.removeClassPrefix('level-')
                    .addClass('level-' + level);
            }
        },

        toggleDisabled: function(val) {
            if (_.isUndefined(val)) val = !this.slider.isEnabled;
            this.slider[val ? 'disable' : 'enable']();
            this.$el.toggleClass("disabled", val);
        },

        ////////////
        // events //
        ////////////
        onModelChange: function(model, value, options) {
            if (this.slider) {
                this.slider.setValue(this.getValue());
                this.setLevelClass();
            }
        },

        onChange: function(e) {
            this.model.set(this.options.attribute, e.value.newValue);
            this.setLevelClass();
        },

    });

    return VSliderbar;
});

